const _ = require('lodash');

module.exports = function (data) {
    return {
        event: 'purchase',
        shopper: {
            Id: data.shopper.Id,
            ABN: data.shopper.ABN,
            OrderCount: data.shopper.OrderCount,
        },
        ecommerce: {
            currencyCode: 'AUD',
            purchase: {
                actionField: {
                    id: data.order.OrderId,
                    affiliation: data.order.PickupStoreName,
                    revenue: data.order.TotalIncludingGst,
                    shipping: data.order.DeliveryFee,
                    coupon: data.order.CouponIDs.join('|'),
                },
                products: _.map(data.order.Products, product => ({
                    name: product.Name,
                    id: product.Stockcode,
                    price: product.SalePrice,
                    brand: product.Brand,
                    quantity: product.Quantity,
                })),
            },
        },
    };
};



// WEBPACK FOOTER //
// ./src/order/confirmation/analytics/order-analytics-mapper-gtm.js